import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Plus, X } from 'lucide-react';
export function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);
  const faqs = [{
    q: '¿La evaluación es realmente gratuita?',
    a: 'Sí, 100% gratuita y sin compromiso. No pedimos tarjeta para hacer el test. Recibes un resumen de tu perfil al finalizar. Los planes con nutriólogo empiezan desde $499 MXN si decides continuar.'
  }, {
    q: '¿Quiénes son los nutriólogos?',
    a: 'Licenciados en Nutrición con cédula profesional expedida por la SEP (Secretaría de Educación Pública). Cada nutriólogo tiene experiencia en consulta online y ejerce de forma independiente. Puedes verificar su cédula en el registro público: cedulaprofesional.sep.gob.mx'
  }, {
    q: '¿Es un servicio médico?',
    a: 'No. FitConecta es una plataforma tecnológica que facilita el acceso a servicios de nutrición proporcionados por profesionales independientes. No realizamos diagnósticos médicos ni sustituimos la consulta con un médico. Si padeces alguna enfermedad, consulta a tu médico antes de iniciar cualquier plan.'
  }, {
    q: '¿Cómo son las consultas?',
    a: 'Por videollamada (Google Meet o Zoom), desde donde estés. No necesitas ir a ningún lugar. El seguimiento entre consultas es por WhatsApp. Tu nutriólogo te responde dudas y ajusta tu plan según tus avances.'
  }, {
    q: '¿Es seguro pagar en FitConecta?',
    a: 'Sí. Todos los pagos se procesan a través de Stripe, una plataforma certificada con encriptación bancaria de nivel mundial. Aceptamos:\n- Tarjeta de crédito o débito\n- Transferencia SPEI (gratis e inmediata)\n- Pago en efectivo en OXXO\n\nNunca almacenamos tu información de pago. Todo es procesado por Stripe.'
  }, {
    q: '¿Puedo cancelar cuando quiera?',
    a: 'El plan de $499 MXN es pago único (no hay cancelación porque no es suscripción).\n\nEl programa mensual de $2,499 tiene compromiso mínimo de 3 meses para poder ver resultados reales. Esto también permite al nutriólogo diseñar un plan progresivo efectivo. Después del 3er mes, puedes cancelar en cualquier momento sin penalización.'
  }];
  return <section id="faq" className="bg-primary py-12 lg:py-20" data-id="element-16">
      <div className="max-w-[720px] mx-auto px-5 md:px-6" data-id="element-17">
        <div className="text-center mb-10 lg:mb-16" data-id="element-18">
          <h2 className="font-serif text-[28px] md:text-[42px] text-text-primary" data-id="element-19">
            Preguntas frecuentes
          </h2>
        </div>

        <div className="space-y-2 lg:space-y-3" data-id="element-20">
          {faqs.map((faq, idx) => {
          const isOpen = openIndex === idx;
          return <motion.div key={idx} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.25,
            delay: idx * 0.05
          }} className="bg-white rounded-2xl px-5 py-2 shadow-sm border border-text-primary/5" data-id="element-21">
                <button onClick={() => setOpenIndex(isOpen ? null : idx)} className="w-full flex items-center justify-between py-4 text-left group" data-id="element-22">
                  <span className="font-sans text-[15px] md:text-[16px] font-medium text-text-primary group-hover:text-accent transition-colors pr-4" data-id="element-23">
                    {faq.q}
                  </span>
                  <div className={`w-8 h-8 rounded-full border flex items-center justify-center transition-all shrink-0 ${isOpen ? 'border-accent bg-accent text-white rotate-0' : 'border-text-primary/20 text-text-primary'}`} data-id="element-24">
                    {isOpen ? <X className="w-4 h-4" data-id="element-25" /> : <Plus className="w-4 h-4" data-id="element-26" />}
                  </div>
                </button>
                <AnimatePresence data-id="element-27">
                  {isOpen && <motion.div initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.3,
                ease: 'easeInOut'
              }} className="overflow-hidden" data-id="element-28">
                      <div className="pb-6 text-[14px] text-text-secondary font-light leading-relaxed pr-10 whitespace-pre-wrap" data-id="element-29">
                        {faq.a}
                      </div>
                    </motion.div>}
                </AnimatePresence>
              </motion.div>;
        })}
        </div>
      </div>
    </section>;
}